import { render } from "./Wheel11.vue?vue&type=template&id=b02a3914"
const script = {}
script.render = render

export default script